module.exports = ".icon-center {\n  vertical-align: middle; }\n\n.cardContainer {\n  padding-top: 10px;\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-bottom: 10px; }\n\n.description-text {\n  margin-top: 15px;\n  margin-bottom: 30px;\n  border-bottom: 1px #ccc solid;\n  padding-bottom: 8px; }\n\nh2 {\n  display: inline-block;\n  font-size: 3em;\n  margin-left: 10px;\n  vertical-align: middle; }\n\nh5 {\n  display: inline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/card-info-control/card-info-control.component.scss
// module id = ./src/app/controls/card-info-control/card-info-control.component.scss
// module chunks = main